import { Typography, styled } from '@mui/material';

export const UserNameInfoText = styled(Typography, {
  shouldForwardProp: (prop: string) => !['maxWidthInfo'].includes(prop),
})<{ maxWidthInfo: string }>(({ maxWidthInfo }) => ({
  width: maxWidthInfo,
  display: 'block',
}));
